{
  "v3.elements.annuler": "Annuler",
  "v3.elements.autre_projet": "Cet élément appartient à un autre projet : ouverture dans son projet…",
  "v3.elements.code.BACKLOG_ITEM_HAS_CHILDREN": "L’élément a des enfants : cochez « inclure les enfants ».",
  "v3.elements.code.BACKLOG_ITEM_IN_ACTIVE_SPRINT": "L’élément ou un descendant est engagé dans le sprint actif : retirez-le d’abord du sprint.",
  "v3.elements.code.BACKLOG_ITEM_IN_RELEASE": "L’élément ou un descendant fait partie du contenu d’une version.",
  "v3.elements.code.BACKLOG_ITEM_REFERENCED": "L’élément ou un descendant est cité par un incident de service.",
  "v3.elements.code.BACKLOG_MERGE_REASON_REQUIRED": "Dites pourquoi ces deux éléments sont un doublon (5 caractères au moins).",
  "v3.elements.code.BACKLOG_MERGE_SAME_ITEM": "Un élément ne se fusionne pas avec lui-même.",
  "v3.elements.code.CHAMP_OBLIGATOIRE_MANQUANT": "Un champ obligatoire du niveau manque.",
  "v3.elements.code.COMMENTAIRE_INTROUVABLE": "Ce commentaire n’existe plus.",
  "v3.elements.code.CONFLIT_DE_VERSION": "L’élément a changé depuis votre lecture : relisez-le avant d’enregistrer.",
  "v3.elements.code.CONTEXTE_INCOMPLET": "Le contexte de la règle est incomplet : le geste est refusé.",
  "v3.elements.code.CREATEUR_N_APPROUVE_PAS": "L’auteur d’un élément ne l’accepte pas lui-même.",
  "v3.elements.code.DROIT_NON_TENU": "Votre profil ne tient pas le droit demandé par ce geste.",
  "v3.elements.code.ELEMENT_INTROUVABLE": "Élément introuvable ou non visible pour vous.",
  "v3.elements.code.FAVORI_TYPE_INCONNU": "Ce type d’objet ne peut pas encore être mis en favori.",
  "v3.elements.code.FIL_DEJA_RESOLU": "Ce fil est déjà résolu.",
  "v3.elements.code.FORMULE_ABSENTE": "Aucune formule de score n’est posée par l’organisation.",
  "v3.elements.code.GATE_NOT_SATISFIED": "Un prérequis de l’état demandé n’est pas satisfait.",
  "v3.elements.code.NIVEAU_HORS_MODELE": "Ce niveau n’existe pas dans le modèle du projet.",
  "v3.elements.code.NOT_FOUND": "Élément introuvable ou non visible pour vous.",
  "v3.elements.code.PARENT_INCOMPATIBLE": "Ce parent n’admet pas ce niveau dans le modèle du projet.",
  "v3.elements.code.PREUVES_MANQUANTES": "L’état final exige des preuves qui manquent encore.",
  "v3.elements.code.PROVENANCE_NON_VALIDE": "La preuve du document source n’est pas valide : relisez le document avant de créer.",
  "v3.elements.code.REACTION_INCONNUE": "Cette réaction n’existe pas.",
  "v3.elements.code.SANS_SESSION": "Votre session a expiré : reconnectez-vous.",
  "v3.elements.code.TRANSITION_HORS_MODELE": "Cette transition n’existe pas dans le modèle du projet.",
  "v3.elements.code.VALIDATION_ERROR": "La saisie n’est pas valide.",
  "v3.elements.code.VERSION_SOURCE_INCOMPATIBLE": "Cette version du document source n’est pas compatible.",
  "v3.elements.code.WORKSPACE_ARCHIVED": "Le projet est archivé : aucune création possible.",
  "v3.elements.collab.activite": "Activité",
  "v3.elements.collab.activite_quoi": "activité",
  "v3.elements.collab.aucun_commentaire": "Aucun commentaire.",
  "v3.elements.collab.aucun_retrolien": "Aucun rétrolien.",
  "v3.elements.collab.aucune_activite": "Aucune activité.",
  "v3.elements.collab.aucune_piece": "Aucune pièce jointe.",
  "v3.elements.collab.commentaires": "Commentaires",
  "v3.elements.collab.commentaires_quoi": "commentaires",
  "v3.elements.collab.commente": "Commentaire publié.",
  "v3.elements.collab.commenter": "Commenter",
  "v3.elements.collab.deplier": "Déplier : {{section}}",
  "v3.elements.collab.evenement.attachment": "pièce jointe",
  "v3.elements.collab.evenement.comment": "commentaire",
  "v3.elements.collab.evenement.created": "création",
  "v3.elements.collab.evenement.status": "changement d’état",
  "v3.elements.collab.fichier": "Fichier à joindre",
  "v3.elements.collab.fichier_invalide": "Fichier vide ou de plus de 10 Mo.",
  "v3.elements.collab.joindre": "Joindre le fichier",
  "v3.elements.collab.joint": "Fichier joint.",
  "v3.elements.collab.mentions_aide": "@pseudo pour mentionner : seules les personnes qui ont accès sont notifiées.",
  "v3.elements.collab.piece_supprimee": "Pièce supprimée.",
  "v3.elements.collab.pieces": "Pièces jointes",
  "v3.elements.collab.pieces_quoi": "pièces jointes",
  "v3.elements.collab.reaction.coeur": "J’aime",
  "v3.elements.collab.reaction.fete": "Bravo",
  "v3.elements.collab.reaction.merci": "Merci",
  "v3.elements.collab.reaction.oeil": "Je regarde",
  "v3.elements.collab.reaction.pouce": "D’accord",
  "v3.elements.collab.reaction.question": "Question",
  "v3.elements.collab.reaction_notee": "Réaction notée.",
  "v3.elements.collab.reactions": "Réactions",
  "v3.elements.collab.replier": "Replier : {{section}}",
  "v3.elements.collab.resolu": "fil résolu",
  "v3.elements.collab.resoudre": "Résoudre le fil",
  "v3.elements.collab.resume": "{{commentaires}} commentaires · {{pieces}} pièces jointes · {{activite}} événements",
  "v3.elements.collab.retroliens": "rétroliens",
  "v3.elements.collab.retroliens_masques": "{{nombre}} autres citations dans des objets que vous ne pouvez pas lire.",
  "v3.elements.collab.rouvrir": "Rouvrir le fil",
  "v3.elements.collab.sans_notification": "Ces mentions ne notifieront personne : {{mentions}}",
  "v3.elements.collab.supprimer": "Supprimer",
  "v3.elements.collab.supprimer_nom": "Supprimer {{nom}}",
  "v3.elements.collab.supprimer_piece_effet": "La pièce est retirée de l’élément et du stockage.",
  "v3.elements.collab.supprimer_piece_titre": "Supprimer « {{nom}} » ?",
  "v3.elements.collab.taille_ko": "{{n}} Ko",
  "v3.elements.collab.telecharger": "Télécharger {{nom}}",
  "v3.elements.collab.titre": "Collaboration",
  "v3.elements.collab.votre_commentaire": "Votre commentaire",
  "v3.elements.creer.afin_de": "Afin de",
  "v3.elements.creer.aucun_champ": "Aucun champ obligatoire pour ce niveau.",
  "v3.elements.creer.aucun_parent": "Aucun parent compatible avec ce niveau dans le projet.",
  "v3.elements.creer.bouton": "Créer l’élément",
  "v3.elements.creer.champ_obligatoire": "Champ obligatoire du niveau : {{champ}}",
  "v3.elements.creer.choisir_parent": "Choisir un parent",
  "v3.elements.creer.compatible": "Le niveau {{niveau}} est admis sous {{parent}}.",
  "v3.elements.creer.criteres": "Critères d’acceptation",
  "v3.elements.creer.criteres_aide": "Un critère par ligne.",
  "v3.elements.creer.en_tant_que": "En tant que",
  "v3.elements.creer.incompatible": "Le niveau {{niveau}} n’est pas admis sous {{parent}}.",
  "v3.elements.creer.je_veux": "Je veux",
  "v3.elements.creer.niveau": "Niveau",
  "v3.elements.creer.niveau_hors_modele": "Le niveau « {{niveau}} » n’existe pas dans le modèle du projet.",
  "v3.elements.creer.origine.cadence": "Origine : fiche de la cadence",
  "v3.elements.creer.origine.fiche": "Origine : fiche de l’élément parent",
  "v3.elements.creer.origine.liste": "Origine : liste des éléments",
  "v3.elements.creer.origine.vue": "Origine : vue du projet",
  "v3.elements.creer.parent": "Parent : {{titre}} ({{niveau}})",
  "v3.elements.creer.parent_a_choisir": "Parent : à choisir (ce niveau n’est pas racine)",
  "v3.elements.creer.parent_racine": "Parent : aucun (élément racine)",
  "v3.elements.creer.parent_seul": "Parent",
  "v3.elements.creer.provenance": "Document source : {{document}}, version {{version}}",
  "v3.elements.creer.racine": "Aucun (élément racine)",
  "v3.elements.creer.recit": "Récit ({{niveau}})",
  "v3.elements.creer.recit_hors_niveau": "S’applique au niveau {{niveau}} seulement.",
  "v3.elements.creer.sans_provenance": "Aucun document source transmis.",
  "v3.elements.creer.succes": "Élément créé.",
  "v3.elements.creer.titre": "Créer un élément",
  "v3.elements.creer.titre_champ": "Titre",
  "v3.elements.creer.titre_obligatoire": "Le titre est obligatoire.",
  "v3.elements.etat.chargement": "Chargement : {{quoi}}…",
  "v3.elements.etat.en_cours": "En cours…",
  "v3.elements.etat.erreur": "Impossible de lire : {{quoi}}.",
  "v3.elements.etat.introuvable": "Introuvable : {{quoi}}.",
  "v3.elements.etat.reessayer": "Réessayer",
  "v3.elements.etat.refus": "Accès refusé : {{quoi}}.",
  "v3.elements.fiche.a_accepter": "à accepter",
  "v3.elements.fiche.accepte": "accepté",
  "v3.elements.fiche.accepter": "Accepter l’élément",
  "v3.elements.fiche.affectations": "Affectations",
  "v3.elements.fiche.affectations_quoi": "affectations disponibles",
  "v3.elements.fiche.affecte": "Affectation enregistrée.",
  "v3.elements.fiche.affecter_cadence": "Affecter la cadence",
  "v3.elements.fiche.affecter_equipe": "Affecter l’équipe",
  "v3.elements.fiche.affecter_responsable": "Affecter le responsable",
  "v3.elements.fiche.affecter_rubrique": "Ranger dans la rubrique",
  "v3.elements.fiche.affecter_version": "Affecter la version",
  "v3.elements.fiche.agent": "Agent {{nom}}",
  "v3.elements.fiche.ajouter_enfant": "Ajouter un enfant",
  "v3.elements.fiche.ajouter_etiquette": "Ajouter l’étiquette",
  "v3.elements.fiche.analyser": "Analyser",
  "v3.elements.fiche.annuler_edition": "Annuler les modifications",
  "v3.elements.fiche.appliquer_etat": "Appliquer l’état",
  "v3.elements.fiche.aucun_axe": "Aucun axe rattaché.",
  "v3.elements.fiche.aucun_doublon": "Aucun doublon absorbé.",
  "v3.elements.fiche.aucun_enfant": "Aucun enfant.",
  "v3.elements.fiche.aucun_impact": "Aucun élément impacté.",
  "v3.elements.fiche.aucun_lien": "Aucun lien.",
  "v3.elements.fiche.aucun_niveau_enfant": "Le modèle n’admet aucun niveau sous celui-ci.",
  "v3.elements.fiche.aucun_workflow": "Aucun workflow déclaré.",
  "v3.elements.fiche.aucune_affectation": "Aucune personne, équipe ni agent disponible.",
  "v3.elements.fiche.aucune_etiquette": "Aucune étiquette dans le projet.",
  "v3.elements.fiche.aucune_rubrique": "Aucune rubrique dans le projet.",
  "v3.elements.fiche.aucune_version": "Aucune version dans le projet.",
  "v3.elements.fiche.auteur": "Auteur : {{auteur}}",
  "v3.elements.fiche.axe": "Axe de l’organisation",
  "v3.elements.fiche.axes": "axes rattachés",
  "v3.elements.fiche.cadence": "Cadence",
  "v3.elements.fiche.cadence_heritee": "Cadence héritée du parent : #{{id}}",
  "v3.elements.fiche.cas_probant": "Cas probant",
  "v3.elements.fiche.cas_relie": "Cas relié.",
  "v3.elements.fiche.choisir": "Choisir",
  "v3.elements.fiche.choisir_etat": "Choisir un état",
  "v3.elements.fiche.cible": "Élément cible",
  "v3.elements.fiche.classe": "Classement enregistré.",
  "v3.elements.fiche.classement": "Classement",
  "v3.elements.fiche.comprendre": "Comprendre et demander un accès",
  "v3.elements.fiche.concevoir_cas": "Concevoir les cas de test",
  "v3.elements.fiche.confirmer_workflow": "Lancer « {{workflow}} » ?",
  "v3.elements.fiche.criteres": "Critères d’acceptation",
  "v3.elements.fiche.criteres_score": "Critères du score",
  "v3.elements.fiche.criteres_score_aide": "Selon la formule de l’organisation : code=valeur, séparés par des virgules.",
  "v3.elements.fiche.decisions": "Décisions",
  "v3.elements.fiche.definition_termine": "définition de terminé",
  "v3.elements.fiche.deplier_impact": "Afficher l’impact",
  "v3.elements.fiche.depot": "Dépôt et livraison",
  "v3.elements.fiche.description": "Description",
  "v3.elements.fiche.detacher_nom": "Détacher {{nom}}",
  "v3.elements.fiche.disponibles": "Disponibles : {{membres}} personnes, {{equipes}} équipes, {{agents}} agents.",
  "v3.elements.fiche.document_source": "Document source",
  "v3.elements.fiche.dod_atteinte": "Terminé prouvé.",
  "v3.elements.fiche.dod_manques": "Manques :",
  "v3.elements.fiche.dod_non_applicable": "Définition de terminé non applicable.",
  "v3.elements.fiche.doublon": "{{titre}} (#{{id}}) absorbé par {{par}} : {{motif}}",
  "v3.elements.fiche.doublons": "doublons absorbés",
  "v3.elements.fiche.edition": "Contenu",
  "v3.elements.fiche.element": "élément",
  "v3.elements.fiche.enfants": "Enfants",
  "v3.elements.fiche.enfants_concernes": "Enfants non terminés : {{liste}}",
  "v3.elements.fiche.enregistre": "Enregistré.",
  "v3.elements.fiche.enregistrer": "Enregistrer",
  "v3.elements.fiche.equipe": "Équipe",
  "v3.elements.fiche.estimation": "Estimation (points)",
  "v3.elements.fiche.etat": "État",
  "v3.elements.fiche.etat_final": "État final : les preuves exigées par le modèle seront vérifiées.",
  "v3.elements.fiche.etiquette": "Étiquette",
  "v3.elements.fiche.etiquettes": "étiquettes",
  "v3.elements.fiche.favori": "Mettre en favori",
  "v3.elements.fiche.favori_ajoute": "Ajouté aux favoris.",
  "v3.elements.fiche.favori_retire": "Retiré des favoris.",
  "v3.elements.fiche.fusionner": "Fusionner un doublon",
  "v3.elements.fiche.generer_enfants": "Décomposer avec l’IA",
  "v3.elements.fiche.gerer_classement": "Gérer le classement",
  "v3.elements.fiche.gestes": "Doublons et suppression",
  "v3.elements.fiche.hierarchie": "Parents et enfants",
  "v3.elements.fiche.hierarchie_quoi": "parents et enfants",
  "v3.elements.fiche.ia": "IA",
  "v3.elements.fiche.ia_lancee": "Travail d’IA lancé.",
  "v3.elements.fiche.impact": "impact",
  "v3.elements.fiche.importer_cas": "Importer les cas produits",
  "v3.elements.fiche.introuvable": "Élément introuvable ou non visible pour vous.",
  "v3.elements.fiche.journal": "Journal de l’élément",
  "v3.elements.fiche.lancer": "Lancer",
  "v3.elements.fiche.lancer_workflow": "Lancer le workflow",
  "v3.elements.fiche.lien_entrant": "← {{relation}}",
  "v3.elements.fiche.lien_retire": "Lien retiré.",
  "v3.elements.fiche.lien_sortant": "{{relation}} →",
  "v3.elements.fiche.liens": "Liens et impact",
  "v3.elements.fiche.liens_quoi": "liens",
  "v3.elements.fiche.membres_non_visibles": "Membres non visibles pour ce profil : {{quoi}} limitées.",
  "v3.elements.fiche.ne_plus_suivre": "Ne plus suivre",
  "v3.elements.fiche.niveau_etat": "Niveau : {{niveau}} · État : {{etat}}",
  "v3.elements.fiche.niveau_non_executable": "Ce niveau n’est pas exécutable selon le modèle.",
  "v3.elements.fiche.non_evalue": "Préparation non évaluée.",
  "v3.elements.fiche.non_suivi": "Vous ne suivez plus cet élément.",
  "v3.elements.fiche.nouvel_etat": "Nouvel état",
  "v3.elements.fiche.nouvelle_acceptation": "Enregistré : une nouvelle acceptation est requise.",
  "v3.elements.fiche.parents": "Parents",
  "v3.elements.fiche.personnes": "Personnes et équipes",
  "v3.elements.fiche.preparation": "préparation",
  "v3.elements.fiche.preuve_fraiche": "Preuve à jour.",
  "v3.elements.fiche.preuve_perimee": "Preuve périmée : le document a changé.",
  "v3.elements.fiche.preuve_remplace": "Document remplacé : rattachez la version renouvelée.",
  "v3.elements.fiche.preuve_source": "preuve du document source",
  "v3.elements.fiche.preuves": "Preuves",
  "v3.elements.fiche.produire_changement": "Produire le changement",
  "v3.elements.fiche.racine": "Élément racine.",
  "v3.elements.fiche.rattachee": "Version rattachée.",
  "v3.elements.fiche.rattacher": "Rattacher la version",
  "v3.elements.fiche.rattacher_axe": "Rattacher l’axe",
  "v3.elements.fiche.reevaluee": "Preuve réévaluée.",
  "v3.elements.fiche.reevaluer": "Réévaluer la preuve",
  "v3.elements.fiche.relation": "Relation",
  "v3.elements.fiche.relie": "Éléments reliés.",
  "v3.elements.fiche.relier": "Relier",
  "v3.elements.fiche.relier_cas": "Relier le cas",
  "v3.elements.fiche.relire_code": "Relire le code",
  "v3.elements.fiche.replier_impact": "Masquer l’impact",
  "v3.elements.fiche.responsable": "Responsable",
  "v3.elements.fiche.responsable_actuel": "Responsable actuel : {{nom}}",
  "v3.elements.fiche.retirer": "Retirer",
  "v3.elements.fiche.retirer_affectation": "Retirer l’affectation",
  "v3.elements.fiche.retirer_favori": "Retirer des favoris",
  "v3.elements.fiche.retirer_lien": "Retirer le lien vers {{autre}}",
  "v3.elements.fiche.retirer_lien_effet": "Le lien disparaît des deux côtés ; les éléments restent.",
  "v3.elements.fiche.retirer_lien_titre": "Retirer le lien vers « {{autre}} » ?",
  "v3.elements.fiche.retirer_nom": "Retirer {{nom}}",
  "v3.elements.fiche.retirer_rattachement": "Retirer le rattachement",
  "v3.elements.fiche.retour": "Retour aux éléments",
  "v3.elements.fiche.rubrique": "Rubrique",
  "v3.elements.fiche.rubrique_actuelle": "Rubrique : {{nom}}",
  "v3.elements.fiche.rubriques": "rubriques",
  "v3.elements.fiche.sans_parent_ni_enfant": "Ni parent ni enfant.",
  "v3.elements.fiche.sans_preuve_source": "Aucun document source rattaché.",
  "v3.elements.fiche.suivi": "Vous suivez cet élément.",
  "v3.elements.fiche.suivre": "Suivre l’élément",
  "v3.elements.fiche.supprimer": "Supprimer l’élément",
  "v3.elements.fiche.titre": "Fiche de l’élément",
  "v3.elements.fiche.titre_champ": "Titre de l’élément",
  "v3.elements.fiche.version_actuelle": "Version cible : {{nom}}",
  "v3.elements.fiche.version_cible": "Version cible",
  "v3.elements.fiche.version_renouvelee": "Version renouvelée",
  "v3.elements.fiche.versions": "Versions",
  "v3.elements.fiche.versions_cibles": "versions cibles",
  "v3.elements.fiche.voir_cadence": "Voir la cadence",
  "v3.elements.fiche.voir_couverture": "Voir la couverture",
  "v3.elements.fiche.vous_etes_auteur": "vous en êtes l’auteur",
  "v3.elements.fiche.workflow": "Workflow",
  "v3.elements.fiche.workflow_etapes": "Étapes : {{etapes}}",
  "v3.elements.fiche.workflows": "workflows",
  "v3.elements.fusion.aide_conserve": "Un autre élément du même niveau ; l’élément courant sera absorbé.",
  "v3.elements.fusion.apercu": "aperçu de la fusion",
  "v3.elements.fusion.aucun_candidat": "Aucun autre élément de même niveau à conserver.",
  "v3.elements.fusion.bouton": "Fusionner",
  "v3.elements.fusion.choisir": "Choisir l’élément conservé",
  "v3.elements.fusion.cible": "Conservé : {{titre}} (#{{id}})",
  "v3.elements.fusion.conserve": "Élément conservé",
  "v3.elements.fusion.deplaces": "Déplacés vers l’élément conservé : {{liste}}",
  "v3.elements.fusion.irreversible": "La fusion est définitive : l’élément absorbé ne pourra pas être rouvert.",
  "v3.elements.fusion.motif": "Motif de la fusion",
  "v3.elements.fusion.motif_aide": "{{min}} caractères au moins, tracés dans le journal.",
  "v3.elements.fusion.references": "La référence de l’élément conservé reste inchangée.",
  "v3.elements.fusion.relu": "J’ai relu les effets de la fusion.",
  "v3.elements.fusion.source": "Absorbé puis supprimé : {{titre}} (#{{id}})",
  "v3.elements.fusion.succes": "Fusion faite.",
  "v3.elements.fusion.titre": "Fusionner un doublon",
  "v3.elements.fusion.vide": "Choisissez l’élément conservé pour voir les effets de la fusion.",
  "v3.elements.geste.erreur": "Le geste a échoué. Réessayez.",
  "v3.elements.geste.refus": "Geste refusé.",
  "v3.elements.ia.arret_organisation": "L’IA est arrêtée par l’organisation : les gestes d’IA sont suspendus.",
  "v3.elements.ia.arret_plateforme": "L’IA est arrêtée sur la plateforme : les gestes d’IA sont suspendus.",
  "v3.elements.ia.disponible": "L’IA est disponible.",
  "v3.elements.liste.affichages": "Affichages",
  "v3.elements.liste.agent": "Un agent",
  "v3.elements.liste.arbre": "hiérarchie des éléments",
  "v3.elements.liste.avancement": "{{termines}} / {{total}} terminés",
  "v3.elements.liste.changer_etat": "Changer l’état de {{titre}}",
  "v3.elements.liste.classement": "Classement",
  "v3.elements.liste.commandes_graphe": "Commandes du graphe",
  "v3.elements.liste.creer": "Créer un élément",
  "v3.elements.liste.de": "De",
  "v3.elements.liste.deplier": "Déplier {{titre}}",
  "v3.elements.liste.effacer": "Effacer les filtres ({{nombre}})",
  "v3.elements.liste.elements": "éléments",
  "v3.elements.liste.entrer_selection": "Sélectionner des éléments",
  "v3.elements.liste.equipe": "Équipe {{nom}}",
  "v3.elements.liste.etat_change": "État changé.",
  "v3.elements.liste.etat_ia": "état de l’IA",
  "v3.elements.liste.filtre_cadence": "Cadence",
  "v3.elements.liste.filtre_etat": "État",
  "v3.elements.liste.filtre_etiquette": "Étiquette",
  "v3.elements.liste.filtre_niveau": "Niveau",
  "v3.elements.liste.filtre_priorite": "Priorité",
  "v3.elements.liste.filtre_responsable": "Responsable ou équipe",
  "v3.elements.liste.filtre_texte": "Rechercher (texte ou référence)",
  "v3.elements.liste.filtres": "Filtres",
  "v3.elements.liste.flux": "Flux cumulé",
  "v3.elements.liste.formule": "Score {{nom}} : {{criteres}}.",
  "v3.elements.liste.graphe": "graphe des éléments",
  "v3.elements.liste.ia": "IA et missions",
  "v3.elements.liste.lancer_mission": "Lancer une mission",
  "v3.elements.liste.legende": "Relations : {{relations}}",
  "v3.elements.liste.limite": "{{colonne}} : {{compte}} / {{max}}",
  "v3.elements.liste.limite_etat.atteinte": "(atteinte)",
  "v3.elements.liste.limite_etat.depassee": "(dépassée)",
  "v3.elements.liste.limite_etat.sous_limite": "(sous la limite)",
  "v3.elements.liste.limites": "Limites d’en-cours",
  "v3.elements.liste.limites_non_definies": "Aucune limite définie.",
  "v3.elements.liste.manquants_zero": "Une valeur manquante compte zéro.",
  "v3.elements.liste.missions": "Missions",
  "v3.elements.liste.missions_vide": "Aucune mission liée.",
  "v3.elements.liste.modele": "Modèle {{modele}}, version {{version}} (figée)",
  "v3.elements.liste.modifier_selection": "Modifier la sélection",
  "v3.elements.liste.moi": "Moi",
  "v3.elements.liste.niveaux": "Niveaux : {{niveaux}}",
  "v3.elements.liste.non_assigne": "Non assigné",
  "v3.elements.liste.non_prete": "Pas prêt : {{manques}}",
  "v3.elements.liste.onglet.graphe": "Graphe",
  "v3.elements.liste.onglet.hierarchie": "Hiérarchie",
  "v3.elements.liste.onglet.liste": "Liste",
  "v3.elements.liste.onglet.preparation": "Prêt à construire",
  "v3.elements.liste.onglet.tableau": "Tableau",
  "v3.elements.liste.prete": "Prêt",
  "v3.elements.liste.prets": "éléments prêts à construire",
  "v3.elements.liste.prets_vide": "Aucun élément évalué pour la construction.",
  "v3.elements.liste.quitter_selection": "Quitter la sélection",
  "v3.elements.liste.rang_annonce": "Rang enregistré.",
  "v3.elements.liste.rang_saisi": "Rang {{rang}}",
  "v3.elements.liste.recentrer": "Recentrer",
  "v3.elements.liste.rediger": "Rédiger les spécifications",
  "v3.elements.liste.regler_limites": "Régler les limites",
  "v3.elements.liste.relation": "Relation",
  "v3.elements.liste.reordonner": "Réordonner {{titre}} (Espace, flèches, Entrée)",
  "v3.elements.liste.replier": "Replier {{titre}}",
  "v3.elements.liste.sans_cadence": "Sans cadence",
  "v3.elements.liste.sans_relation": "Aucune relation entre les éléments.",
  "v3.elements.liste.score": "score de priorité",
  "v3.elements.liste.score_valeur": "Score {{score}}",
  "v3.elements.liste.selection": "Sélection ({{nombre}})",
  "v3.elements.liste.selectionner": "Sélectionner {{titre}}",
  "v3.elements.liste.titre": "Éléments du produit",
  "v3.elements.liste.trier_score": "Trier par score",
  "v3.elements.liste.vers": "Vers",
  "v3.elements.liste.vide": "Aucun élément dans ce projet.",
  "v3.elements.liste.vide_filtre": "Aucun élément ne correspond aux filtres.",
  "v3.elements.liste.vider_selection": "Vider la sélection",
  "v3.elements.liste.zoom_arriere": "Zoom arrière",
  "v3.elements.liste.zoom_avant": "Zoom avant",
  "v3.elements.modele": "modèle du projet",
  "v3.elements.priorite.critical": "Critique",
  "v3.elements.priorite.high": "Haute",
  "v3.elements.priorite.low": "Basse",
  "v3.elements.priorite.medium": "Moyenne",
  "v3.elements.sans_projet": "Choisissez un projet pour voir ses éléments.",
  "v3.elements.supprimer.bouton": "Supprimer définitivement",
  "v3.elements.supprimer.cible": "Élément à supprimer : {{titre}}",
  "v3.elements.supprimer.confirmer": "Je comprends que la suppression est définitive.",
  "v3.elements.supprimer.effets": "effets de la suppression",
  "v3.elements.supprimer.enfants": "Enfants concernés : {{nombre}}",
  "v3.elements.supprimer.enfants_exiges": "Cochez « inclure les enfants » : cet élément en a {{nombre}}.",
  "v3.elements.supprimer.inclure_enfants": "Supprimer aussi ses {{nombre}} enfants : {{noms}}",
  "v3.elements.supprimer.irreversible": "Cette suppression est définitive : rien ne pourra être restauré.",
  "v3.elements.supprimer.preuves": "Commentaires concernés : {{commentaires}} · cas de test reliés : {{cas}}",
  "v3.elements.supprimer.sans_enfant": "Cet élément n’a aucun enfant.",
  "v3.elements.supprimer.succes": "Élément supprimé.",
  "v3.elements.supprimer.titre": "Supprimer un élément",
  "v3.elements.tous": "Tous",
  "v3.elements.toutes": "Toutes",
  "v3.elements.vague_ulterieure": "« {{ecran}} » : écran non encore réalisé (vague {{vague}}).",
  "v3.elements.vues.appliquer": "Filtre enregistré",
  "v3.elements.vues.aucun": "Aucun",
  "v3.elements.vues.aucun_filtre": "Aucun filtre enregistré.",
  "v3.elements.vues.aucune_vue": "Aucune vue personnelle.",
  "v3.elements.vues.confirmer_effet": "Les membres du projet qui l’utilisent ne le retrouveront plus.",
  "v3.elements.vues.confirmer_titre": "Supprimer le filtre « {{nom}} » ?",
  "v3.elements.vues.enregistre": "Enregistré.",
  "v3.elements.vues.enregistrer_filtre": "Enregistrer le filtre",
  "v3.elements.vues.enregistrer_vue": "Enregistrer comme ma vue",
  "v3.elements.vues.filtres": "filtres enregistrés",
  "v3.elements.vues.mes_vues": "mes vues",
  "v3.elements.vues.nom": "Nom du filtre",
  "v3.elements.vues.nom_defaut": "Ma vue",
  "v3.elements.vues.nom_obligatoire": "Donnez un nom au filtre.",
  "v3.elements.vues.partagees_plus_tard": "Le partage d’une vue viendra plus tard.",
  "v3.elements.vues.supprime": "Filtre supprimé.",
  "v3.elements.vues.supprimer": "Supprimer {{nom}}",
  "v3.elements.vues.supprimer_verbe": "Supprimer"
}
